import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { isContentstackEnabled } from 'yoda-site-components/lib/cms-renderer/utils';
import Iris from './Iris';
import Contentstack from './Contentstack';
import { CONTENTSTACK_PAGE_LIST } from './../../../helper/constants/constantPagelist';

/**
 * Marketing — Entry point / Switcher.
 * Checks feature flag and routes to Iris or Contentstack.
 * Both are parallel. No interconnection.
 */
function Marketing(props) {
    const { enableContentstackCMS, contentstackPageList, contentstackPageExclusionList, location } = props;

    const mergedPageList = getMergedPageList(contentstackPageList,contentstackPageExclusionList);

    if (isContentstackEnabled(enableContentstackCMS, location, mergedPageList)) {
        return <Contentstack {...props} />;
    }

    return <Iris {...props} />;
}

const getMergedPageList = (configPageList = [], configPageExclusionList = []) => {
    if (configPageList.length === 0) return [];

    const configSet = new Set(configPageList);
    const configExclusionSet = new Set(configPageExclusionList);

    return [
        ...configPageList,
        ...CONTENTSTACK_PAGE_LIST.filter(
            (url) => !configSet.has(url) && !configExclusionSet.has(url)
        ),
    ];
};



const mapStateToProps = ({ context }) => {
    const featureFlags = get(context, 'featureFlags', {});
    const preferences = get(context, 'preferences', {});

    return {
        enableContentstackCMS: featureFlags.enableContentstackCMS || false,
        contentstackPageList: get(preferences, 'contentstackPageList', []),
        contentstackPageExclusionList: get(preferences, 'contentstackPageExclusionList', []),
    };
};

export default withRouter(connect(mapStateToProps)(Marketing));
